import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { parseJSON } from 'date-fns';
export class HistoricAgreementStatsModel {
    static makeEmpty() {
        let { date } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return new HistoricAgreementStatsModel({
            businessId: '',
            date: (date || new Date()).toISOString(),
            activeAgreementsCount: 0,
            activeAgreementsMonthlyRecurringValue: '$0',
            proposalsCount: 0,
            proposalsMonthlyRecurringValue: '$0'
        });
    }
    date() {
        return this._date;
    }
    agreementsCount() {
        return this.dto.activeAgreementsCount;
    }
    agreementsDollarAmount() {
        return this.dto.activeAgreementsMonthlyRecurringValue.split('.')[0];
    }
    proposalsCount() {
        return this.dto.proposalsCount;
    }
    proposalsDollarAmount() {
        return this.dto.proposalsMonthlyRecurringValue.split('.')[0];
    }
    setActiveAgreementsCount(count) {
        return new HistoricAgreementStatsModel(_object_spread_props(_object_spread({}, this.dto), {
            activeAgreementsCount: count
        }));
    }
    setProposalsCount(count) {
        return new HistoricAgreementStatsModel(_object_spread_props(_object_spread({}, this.dto), {
            proposalsCount: count
        }));
    }
    constructor(dto){
        _define_property(this, "dto", void 0);
        _define_property(this, "_date", void 0);
        this.dto = dto;
        this._date = parseJSON(dto.date);
    }
}
